<header
  class="workflow-topbar"
  [class.is-sticky]="data.sticky"
  [class.has-partner-divider]="data.partnerDivider"
  [class.is-glass]="data.glassmorphism"
  [ngStyle]="topbarStyle"
  [attr.aria-label]="data.ariaLabel || 'Workflow navigation'">
  <div class="navigation-group">
    <button
      *ngIf="showBack"
      type="button"
      class="back-button"
      title="Go back"
      aria-label="Go back"
      (click)="handleBackClick()">
      <mat-icon>chevron_left</mat-icon>
    </button>

    <nav class="breadcrumbs" aria-label="Breadcrumb">
      <ng-container *ngFor="let item of breadcrumbs; let last = last">
        <button
          type="button"
          class="breadcrumb-item"
          [class.is-link]="!!item.route"
          [disabled]="!item.route"
          (click)="handleBreadcrumbClick(item)">
          {{ item.label }}
        </button>
        <span class="breadcrumb-separator" *ngIf="!last">/</span>
      </ng-container>
      <span class="breadcrumb-separator" *ngIf="breadcrumbs.length && currentLabel">/</span>
      <span class="current-label" *ngIf="currentLabel" [title]="currentLabel">{{ currentLabel }}</span>
    </nav>

    <span class="version-badge" *ngIf="versionLabel">{{ versionLabel }}</span>
    <span
      class="status-badge"
      *ngIf="statusLabel"
      [attr.data-tone]="statusTone">
      {{ statusLabel }}
    </span>
  </div>

  <div class="partner" [class.has-divider]="data.partnerDivider" *ngIf="data.partnerLogo?.imageSrc || data.partnerLogo?.text">
    <img
      *ngIf="data.partnerLogo?.imageSrc; else partnerText"
      class="partner-image"
      [src]="data.partnerLogo?.imageSrc"
      [alt]="data.partnerLogo?.alt || data.partnerLogo?.text || 'Partner brand'"
      (load)="handleLogoLoad('partner', $event)"
      (error)="handleLogoError('partner', $event)" />
    <ng-template #partnerText>
      <span class="partner-text">{{ data.partnerLogo?.text }}</span>
    </ng-template>
  </div>
</header>
